import { FilterFn } from '@tanstack/react-table'

import { useState } from 'react'
import PageMasthead from '../../components/PageMasthead'
import { useTitle } from '../../components/TitleProvider'
import AdminActionBar from '../../components/admin/AdminActionBar'
import InfoCallout from '../../components/callout/InfoCallout'
import SearchInput from '../../components/SearchInput'
import CommenterTable from '../../components/commenter/CommenterTable'

declare module '@tanstack/table-core' {
    interface FilterFns {
        fuzzy: FilterFn<unknown>
    }
}

function CommenterListPage() {
    useTitle('Commenter admin')
    const [globalFilter, setGlobalFilter] = useState('')

    return (
        // Same shell as User management: masthead, a controls strip beneath it, then
        // the table filling its card in the content region.
        <div className="flex min-h-0 w-full flex-1 flex-col bg-ink-50">
            <PageMasthead
                title="Commenter admin"
                subtitle="Search for social media users who have commented on posts"
            />

            {/* Search and filters, in a section beneath the masthead */}
            <AdminActionBar>
                <div className="flex-1">
                    <SearchInput
                        keyword={globalFilter ?? ''}
                        onKeywordChange={(value) => setGlobalFilter(String(value))}
                        onSearch={(value) => setGlobalFilter(String(value))}
                    />
                </div>
            </AdminActionBar>

            {/* Content: the Instagram-only note as a callout, then the table card */}
            <div className="flex-1 px-6 py-4">
                <InfoCallout>Instagram users only</InfoCallout>
                <CommenterTable globalFilter={globalFilter} />
            </div>
        </div>
    )
}

export default CommenterListPage
